// components/icons/paymentLogos.tsx — Logo resmi per metode bayar (repo veritrans/logo).
// Landscape semua → tinggi seragam h-6, lebar auto (jangan dipaksa kotak).
import React from 'react';

type P = { className?: string };

const logo = (src: string, alt: string): React.FC<P> => ({ className }: P = {}) => (
    <img src={src} alt={alt} loading="lazy" className={className || 'h-6 w-auto max-w-[72px] object-contain shrink-0'} />
);

export const QrisLogo = logo('/icons/pay-qris.png', 'QRIS');
export const BcaLogo = logo('/icons/pay-bca.png', 'BCA');
export const MandiriLogo = logo('/icons/pay-mandiri.png', 'Mandiri');
export const BriLogo = logo('/icons/pay-bri.png', 'BRI');
export const BniLogo = logo('/icons/pay-bni.png', 'BNI');
export const PermataLogo = logo('/icons/pay-permata_bank.png', 'Permata');
export const CimbLogo = logo('/icons/pay-cimbniaga.png', 'CIMB Niaga');
export const ShopeepayLogo = logo('/icons/pay-shopeepay.png', 'ShopeePay');
export const MastercardLogo = logo('/icons/pay-mastercard.png', 'Kartu Kredit');
export const OvoLogo = logo('/icons/pay-ovo.svg', 'OVO');
export const DanaLogo = logo('/icons/pay-dana.png', 'DANA');
export const LinkajaLogo = logo('/icons/pay-linkaja.svg', 'LinkAja');

// Pemetaan nilai metode -> logo (dipakai form + switcher thanks-page agar sama).
const DUITKU_ICONS: [RegExp, React.FC<P>][] = [
    [/qris/i, QrisLogo], [/bca/i, BcaLogo], [/mandiri/i, MandiriLogo], [/bri/i, BriLogo],
    [/bni/i, BniLogo], [/permata/i, PermataLogo], [/cimb/i, CimbLogo], [/shopeepay/i, ShopeepayLogo],
    [/kartu kredit|credit/i, MastercardLogo], [/ovo/i, OvoLogo], [/dana/i, DanaLogo], [/linkaja/i, LinkajaLogo],
];

/** Logo resmi utk nilai metode ('Duitku Mandiri Virtual Account', 'QRIS', ...). undefined bila tak dikenal. */
export const duitkuLogoFor = (method?: string | null): React.FC<P> | undefined =>
    (method ? DUITKU_ICONS.find(([re]) => re.test(method))?.[1] : undefined);
